import type { GeoCircle } from "schema-dts"

import { useTranslation } from "@bounce/i18n"

import { getGeoCoordinatesSpecification } from "./StructuredData"
import type { GeoCoordinatesProps } from "./StructuredData"

const AREA_SERVED_RADIUS_METERS = 1000
const CURRENCIES_ACCEPTED = [
  "USD",
  "EUR",
  "JPY",
  "GBP",
  "MXN",
  "CAD",
  "UZS",
  "KRW",
  "BRL",
  "TWD",
  "ZAR",
  "NZD",
  "EGP",
  "SAR",
  "PLN",
  "TZS",
  "THB",
  "HKD",
  "ILS",
  "MOP",
  "MYR",
  "SGD",
  "QAR",
  "AUD",
  "CHF",
]

/**
 * @see https://schema.org/paymentAccepted
 */
export const PaymentAcceptedSpecification = () => {
  const { t } = useTranslation()

  return {
    "@type": "PaymentAccepted",
    name: [
      t("cmp.structuredData.paymentAccepted.card", "Credit Card"),
      t("cmp.structuredData.paymentAccepted.paypal", "PayPal"),
      t("cmp.structuredData.paymentAccepted.applePay", "Apple Pay"),
      t("cmp.structuredData.paymentAccepted.googlePay", "Google Pay"),
    ].join(", "),
  }
}

/**
 * @see https://schema.org/areaServed
 */
export const getAreaServedSpecification = ({ latitude, longitude }: GeoCoordinatesProps): GeoCircle | undefined =>
  latitude && longitude
    ? {
        "@type": "GeoCircle",
        geoMidpoint: getGeoCoordinatesSpecification({ latitude, longitude }),
        geoRadius: AREA_SERVED_RADIUS_METERS,
      }
    : undefined

/**
 * @see https://schema.org/currenciesAccepted
 */
export const getCurrenciesAcceptedSpecification = () => {
  return {
    "@type": "CurrenciesAccepted",
    name: CURRENCIES_ACCEPTED.join(", "),
  }
}
